import { useEffect, useState } from 'react'

const promises: { [key: string]: Promise<any> } = {}

export const useFetchCatche = <T> (fetchFn: () => Promise<T>, cacheKey: string) => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [data, setData] = useState<T>()

  //todo use Callback????
  const fetchData = async () => {
    setError('')
    setLoading(true)
    try {
      if (!(cacheKey in promises)) {
        promises[cacheKey] = fetchFn()
      }
      const result = await promises[cacheKey]
      setData(result)
    } catch (error: any) {
      setError(error.toString())
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
    return () => {
      delete promises[cacheKey]
    }
  }, [])

  return { data, loading, error, fetchData }
}
